import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Rx';
import { MatDialog, MatDialogRef } from '@angular/material';

import { Template } from './template.model';
import { TemplatesService } from './templates.service';
import { UsersService } from '../users/users.service';
import { ListItemAnimation } from '../shared/list-item.animation';
import { FadeInAnimation } from '../shared/fade-in.animation';
import { TimeOrDatePipe } from '../shared/time-or-date.pipe';
import { Workflow } from '../workflows/workflow.model';
import { AuthService } from '../auth/auth.service';
import { ConfirmDialogComponent } from '../shared/confirm-dialog.component';
import { SupportService } from 'app/shared/support.service';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss'],
  animations: [ListItemAnimation(), FadeInAnimation]
})
export class TemplatesComponent implements OnInit {
  @Input() workflows: Workflow[] = [];
  count = 0;
  currentUser = this.authService.currentUser;
  form: FormGroup;
  loading = true;
  page = 1;
  search: string;
  splitRegex: RegExp;
  status: string;
  subscription: Subscription;
  templates: Template[] = [];
  total = 0;
  userOnly = false;
  workflowId: number;
  supportLink: string;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<TemplatesComponent>,
    private templatesService: TemplatesService,
    private usersService: UsersService,
    private supportService: SupportService
  ) {
    this.supportLink = this.supportService.link;
  }

  get totalPages(): number { return Math.ceil(+this.total / 10); };

  ngOnInit() {
    const searchControl = new FormControl(null, []);
    searchControl.valueChanges.debounceTime(500).subscribe((value) => {
      this.search = value;
      this.loadPage(1);
    });

    const workflowControl = new FormControl(null, []);
    workflowControl.valueChanges.subscribe((value) => {
      this.workflowId = value;
      this.loadPage(1);
    });

    const statusControl = new FormControl(null, []);
    statusControl.valueChanges.subscribe((value) => {
      this.status = value;
      this.loadPage(1);
    });

    this.form = new FormGroup({
      search: searchControl,
      workflowId: workflowControl,
      status: statusControl
    });

    if (this.workflows.length > 0) {
      this.loadTemplates();
    }
  }

  toggleUserOnly() {
    this.userOnly = !this.userOnly;
    this.loadPage(1);
  }

  onSubmit() {
    this.loadTemplates();
  }

  loadPage(page) {
    this.page = page;
    this.loadTemplates();
  }

  loadTemplates() {
    this.loading = true;
    this.splitRegex = null;
    this.templates = [];
    if (this.subscription != null) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
    this.subscription = this.templatesService.getTemplates(
      this.page,
      this.search,
      this.workflowId,
      this.status,
      this.userOnly).subscribe(
        (data) => {
          this.templates = data.templates;
          this.count = data.templates.length;
          this.total = data.total;
          if (this.search != null && this.search != '') {
            this.splitRegex = new RegExp('(\\b' + this.search.regExpEscape() + ')', 'gi');
          }
          this.loading = false;
        },
        (errors) => {
          this.count = 0;
          this.total = 0;
          this.loading = false;
        }
      );
  }

  selectTemplate(template) {
    let workflow: Workflow;
    if (template != null) {
      workflow = this.workflows.find((w) => w.id === template.workflowId);
    }
    this.dialogRef.close({ template: template, workflow: workflow });
  }


  showDeleteDialog(template) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      height: '240px',
      width: '320px',
      data: {
        action: 'Delete',
        message: 'Delete the template',
        question: template.name
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != null && result.confirm === true) {
        this.deleteTemplate(template);
      }
    });
  }

  deleteTemplate(template) {
    this.templatesService.deleteTemplate(template).subscribe(
      (result) => {
        console.log('Template Successfully Deleted');
        this.loadTemplates();
      },
      (error) => {
        console.log('Failed to Delete Template');
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/templates/templates.component.ts